/* eslint-disable no-underscore-dangle */
import { combineReducers, configureStore } from '@reduxjs/toolkit';
import megaMenuReducer from 'redux/modules/mega-menu/reducer';
import taxonomyReducer from 'redux/modules/taxonomy/reducer';
import pageReducer from 'redux/modules/page/reducer';
import autoSuggestReducer from 'redux/modules/auto-suggest/reducer';
import { isWindowAvailable } from 'utils/browser';
import searchReducer from 'redux/modules/search/reducer';

const reducer = combineReducers({
  megaMenu: megaMenuReducer,
  taxonomy: taxonomyReducer,
  page: pageReducer,
  search: searchReducer,
  autoSuggest: autoSuggestReducer,
});

export const createStore = () =>
  configureStore({
    reducer,
    devTools: true,
    preloadedState: isWindowAvailable ? window?.__WTR_COMMON__?.header?.preloadedState : {},
  });

export type WtrStore = ReturnType<typeof createStore>;
export type WtrGetState = WtrStore['getState'];
export type WtrInferredDispatch = WtrStore['dispatch'];
